import { forwardRef } from 'react';
import RadioInternal from './radio-internal';
var Radio = forwardRef(RadioInternal);
export default Radio;
